import axios from "../../../axios/index.js";
import store from "@/store/store.js";
import constants from "../../../../constants";
import MD5 from "crypto-js/md5";

// Token Refresh
let isAlreadyFetchingAccessToken = false;
let subscribers = [];

function onAccessTokenFetched(access_token) {
  subscribers = subscribers.filter(callback => callback(access_token));
}

function addSubscriber(callback) {
  subscribers.push(callback);
}

export default {
  init() {
    axios.interceptors.response.use(
      function(response) {
        return response;
      },
      function(error) {
        // const { config, response: { status } } = error
        const { config, response } = error;
        const originalRequest = config;

        // if (status === 401) {
        if (response && response.status === 401) {
          if (!isAlreadyFetchingAccessToken) {
            isAlreadyFetchingAccessToken = true;
            store.dispatch("auth/fetchAccessToken").then(access_token => {
              isAlreadyFetchingAccessToken = false;
              onAccessTokenFetched(access_token);
            });
          }

          const retryOriginalRequest = new Promise(resolve => {
            addSubscriber(access_token => {
              originalRequest.headers.Authorization = `Bearer ${access_token}`;
              resolve(axios(originalRequest));
            });
          });
          return retryOriginalRequest;
        }
        return Promise.reject(error);
      }
    );
  },
  login(email, pwd) {
    return new Promise((resolve, reject) => {
      store.dispatch("auth/authenticate", {
        strategy: "local",
        email,
        password: pwd
      }).then(res => {
      //  console.log('userSData',res.user.company[0].name);
      //  console.log("user logged in successfully");
        if(res.user.company[0]){
          window.$cookies.set('companyName', res.user.company[0].name, Infinity);
          window.$cookies.set('organizationType', res.user.company[0].organizationType, Infinity);
        }

        // return res;
        resolve(res)
      })
        .catch(err => {
          store.dispatch("companyManagement/fetchCompanies", {query:{email:email,companyPassword:MD5(pwd).toString()}}).then(res => {
            window.$cookies.set('companyId', res.data[0].id, Infinity);
            window.$cookies.set('enterpriseType', res.data[0].enterpriseType, Infinity);
            window.$cookies.set('companyName', res.data[0].name, Infinity);
            window.$cookies.set('organizationType', res.data[0].organizationType, Infinity);
            // return res;
            resolve(res)
          })
            .catch(err => {
              // return err;
              reject(err)
            });
        });
    });
  },
  registerUser(id, fn, ln, e, jt, c, p, s,iv) {
    return new Promise((resolve, reject) => {
      const userObj = {
        firstName: fn,
        lastName: ln,
        email: e,
        // job_title: jt,
        // company: c,
        password: p,
        status: s,
        isVerified: iv
      };
      store
        .dispatch("users/patch", [id, userObj])
        .then(res => {
          // return res;
          resolve(res)
        })
        .catch(err => {
          // return err;
          reject(err)
        });
    });
  },
  refreshToken() {
    return axios.post("/api/auth/refresh-token", {
      accessToken: localStorage.getItem("accessToKen")
    });
  }
};
